import React, { useState } from "react";
import { useHistory } from "react-router";
import { makeStyles, useTheme } from "@material-ui/core";

import { AppBar } from "@material-ui/core";
import { Toolbar } from "@material-ui/core";
import { useMediaQuery } from "@material-ui/core";
import Hamberger from "./hemberger.comonent";
import { Link } from "react-router-dom";
import { Link as MLink } from "@material-ui/core";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: 20,
    color: "#3f51b5",
  },
  root: {
    padding: 5,
    display: "flex",
    textDecoration: "underline",
    justifyContent: "center",
  },
  main: {
    width: "100%",
    backgroundColor: "#090900",
    [theme.breakpoints.down("xs")]: {
      width: "auto",
    },
  },
  seprate: {
    display: "flex",
    justifyContent: "space-between",
  },
}));

const Header = () => {
  const theme = useTheme();
  const history = useHistory();
  const [toggle, setToggle] = useState(true);

  const matches = useMediaQuery(theme.breakpoints.down("xs"));
  const classes = useStyles();

  const handleClick = () => {
    setToggle(!toggle);
    toggle ? history.push("/social") : history.push("/portfolio");
  };

  return (
    <div>
      {matches ? (
        <Hamberger color="secondary" />
      ) : (
        <div className={classes.seprate}>
          <AppBar variant="contained" className={classes.main}>
            <Toolbar className={classes.root}>
              <div>
                <AccountCircleIcon onClick={handleClick} />
              </div>

              <Link to="/portfolio" className={classes.margin}>
                Home
              </Link>
              <Link to="/about" className={classes.margin}>
                About
              </Link>
              <Link to="/contact" className={classes.margin}>
                Contact
              </Link>
              <Link to="/project" className={classes.margin}>
                Project
              </Link>
              <MLink
                href="https://drive.google.com/file/d/1RHTwdkJT2U8mHhJ9rOYMXOjBvUriapQc/view?usp=sharing"
                className={classes.margin}
              >
                Resume
              </MLink>
            </Toolbar>
          </AppBar>
        </div>
      )}
    </div>
  );
};

export default Header;
